import React, {createContext, useReducer} from 'react'

export const SET_COGNITO_CLIENTS_LIST = 'SET_COGNITO_CLIENTS_LIST'
export const SELECT_COGNITO_CLIENT = 'SELECT_COGNITO_CLIENT'
export const SET_SHOW_COGNITO_CLIENT_POPUP = 'SET_SHOW_COGNITO_CLIENT_POPUP'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_COGNITO_CLIENTS_LIST:
      return { ...data, cognito_clients_list: payload.data }
    case SELECT_COGNITO_CLIENT:
      return {
        ...data,
        selected_client: payload.data.selected_client,
        show_cognito_client_popup: payload.data.show_cognito_client_popup,
      }
    case SET_SHOW_COGNITO_CLIENT_POPUP:
      return {
        ...data,
        show_cognito_client_popup: payload.data,
        selected_client: payload.data ? data.selected_client : {},
      }
    default:
      return data
  }
}

const initialState = {
  cognito_clients_list: [],
  selected_client: {},
  show_cognito_client_popup: false,
}

const CognitoClientsStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <CognitoClientsContext.Provider value={[state, dispatch]}>
      {children}
    </CognitoClientsContext.Provider>
  )
}

export const CognitoClientsContext = createContext(initialState)
export default CognitoClientsStore
